import { render, staticRenderFns } from "./SuccessRateHomeNew.vue?vue&type=template&id=012f455f&scoped=true&"
import script from "./SuccessRateHomeNew.vue?vue&type=script&lang=js&"
export * from "./SuccessRateHomeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f455f",
  null
  
)

export default component.exports